import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { useUser } from "../redux/services/authSlice";
import ResetPassword from "../pages/auth/ResetPassword";
import ChangePasswordPage from "../pages/auth/ChangePassword";
import DefaultLayout from "../components/Navigationbar/DefaultLayout";
import Login from "../pages/auth/Login";
import Dashboard from "../pages/dashboard";
import Classes from "../pages/classes";
import Contest from "../pages/contest";
import Balance from "../pages/balance";
import Transaction from "../pages/balance/transaction";
import Withdrawal from "../pages/balance/withdrawal";
import KYC from "../pages/kyc";
import QA from "../pages/qa";
import Feedback from "../pages/feedback";
import EditProfile from "../pages/auth/Edit-profile";
import ViewResult from "../pages/qa/result";
import ViewSolution from "../pages/qa/solution";

const Allroutes = () => {
  const { user } = useUser();
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");
    const userId = queryParams.get("userId");
    if (token) {
      localStorage.setItem("token", token);
      localStorage.setItem("userId", userId);
    }
    setTimeout(() => {
      if (window.location.search.includes("token=")) {
        window.history.replaceState(null, "", window.location.pathname);
      }
    }, 5000);
    const checkAuth = () => {
      setLoading(false);
    };

    setTimeout(checkAuth, 500);
  }, [ location]);
  if (loading) {
    return (
      <div className="h-screen">
        Loading...
      </div>
    );
  }
  return (
    <React.Suspense fallback={""}>
      <Routes>
        {(Object.keys(user).length > 0 || localStorage.getItem("token")) ? (
          <Route path="" element={<DefaultLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/classes" element={<Classes />} />
            <Route path="/contest" element={<Contest />} />
            <Route path="/deposit" element={<Balance />} />
            <Route path="/withdrawal" element={<Withdrawal />} />
            <Route path="/transaction" element={<Transaction />} />
            <Route path="/kyc" element={<KYC />} />
            <Route path="/qa" element={<QA />} />
            <Route path="/view-result" element={<ViewResult />} />
            <Route path="/view-solution" element={<ViewSolution />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/edit-profile" element={<EditProfile />} />
            <Route path="/change-password" element={<ChangePasswordPage />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        ) : (
          <Route>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Route>
        )}

        <Route
          path="*"
          element={
            <Navigate
              to={Object.keys(user).length > 0 ? "/dashboard" : "/login"}
              replace
            />
          }
        />
      </Routes>
      
    </React.Suspense>
  );
};

export default Allroutes;
